const Roles = Object.freeze({
  ADMIN: "admin",
  CLIENT: "client",
});

export default Roles;
